import { RithmicCandleType, RithmicSystemsTypes } from 'api/http/models'

export const RITHMIC_SYSTEM = {
    [RithmicSystemsTypes.RITHMIC_01]: 'Live trading',
    [RithmicSystemsTypes.RITHMIC_PAPER_TRADING]: 'Demo trading',
}

export const RITHMIC_CANDLE_TYPE: Record<RithmicCandleType, string> = {
    [RithmicCandleType.TICK]: 'Тик',
    [RithmicCandleType.SECOND]: 'Секунда',
}

// Версии алгоритма доливки (выбираются на инструмент)
export const STAIR_VERSION_SAFE = 'safe'
export const STAIR_VERSION_GAP = 'gap_protect'
export const STAIR_VERSION_FIBONACCI = 'fibonacci'
export const STAIR_VERSION_CLASSIC = 'classic'

export const STAIR_VERSION: Record<string, string> = {
    [STAIR_VERSION_SAFE]: 'Безопасный',
    [STAIR_VERSION_GAP]: 'Защита от гэпа',
    [STAIR_VERSION_FIBONACCI]: 'Фибоначчи',
    [STAIR_VERSION_CLASSIC]: 'Классическая (16.06.2026)',
}

// Полные подписи для формы (галочки)
export const STAIR_VERSION_OPTIONS: { value: string; label: string }[] = [
    {
        value: STAIR_VERSION_SAFE,
        label: 'Безопасный — пропорционально просадке, добивает MAX к full_drawdown% (по умолчанию)',
    },
    {
        value: STAIR_VERSION_GAP,
        label: 'Защита от гэпа — на гэпе средняя подтягивается к ⅓ от цены (итог-объём ×3)',
    },
    {
        value: STAIR_VERSION_FIBONACCI,
        label: 'Фибоначчи — размер доливки = сумма двух предыдущих, с первой доливки',
    },
    {
        value: STAIR_VERSION_CLASSIC,
        label: 'Классическая (торговля 16.06.2026) — средняя подтягивается к цене (≈1 тейк-профит), без потолка просадки',
    },
]
